import { render, staticRenderFns } from "./EgyptDestinations.vue?vue&type=template&id=65c15672&"
import script from "./EgyptDestinations.vue?vue&type=script&lang=js&"
export * from "./EgyptDestinations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports